import { call, put, select } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { interactionTriggered } from 'features/application/actions';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { logger } from 'utils/logger';
import { selectMediaDevicePermissions } from 'features/user-media/userMediaSlice';
import { PermissionStatus } from 'features/user-media/types';

export function* unmuteAudioSaga() {
  const canBroadcastAudio: boolean = yield call(hasPermissionsSaga, PermissionTypes.broadcastAudio);

  if (!canBroadcastAudio) {
    logger.remote().info('Tried to unmute audio without broadcast permission');
    return;
  }

  const micPermissions: PermissionStatus = yield select(selectMediaDevicePermissions, 'audioinput');
  if (micPermissions !== 'granted') {
    logger.remote().warn('Tried to unmute audio without media device permission');
    return;
  }

  yield put(interactionTriggered('unmuteAudio'));
  yield call(RTCClient.publishingFeed.startAudioBroadcasting);
}
